<template>
  <div id="A0" class="sub">
    <div class="wrapper">
      <kg-header :headerType="Number(headerType)" />
      <div id="content">
        <div class="inner_static">
          <section class="sec_about">
            <h1 class="tit1">カグルとは？</h1>
            <p class="lead_upper">
              「カグル」の最大の特徴は、お客様自身がプランニングしそのまま注文できることです。プランニングをして出力されるデータは、国内外で特許を取得した独自のシステムにより全て自動生成。人手や手間を無くすことでオーダー家具でありながら低価格かつ短納期を実現した、オーダー家具の常識を覆す家具アプリです。
            </p>
            <ol class="lst_about">
              <li>
                <strong class="cnt">お客様自身が簡単プランニング！</strong>
              </li>
              <li>
                <strong class="cnt">世界唯一の家具製造システムで工場とダイレクトにオーダー家具を注文！</strong>
              </li>
              <li>
                <strong class="cnt">エスクロー方式採用で安くて安心な決済！</strong>
              </li>
            </ol>
            <div class="flow_wrap">
              <article class="arti_flow">
                <h5 class="tit">従来のオーダー家具</h5>
                <p class="lead">
                  多くの人手と<br>
                  時間がかかり高額に…
                </p>
                <div class="wrap_lst_flow1">
                  <ol class="lst_flow1">
                    <li>
                      <div class="ins_wrap_flow">
                        <ol class="ins_lst_flow">
                          <li>
                            <p class="bx">見積り依頼</p>
                          </li>
                          <li>
                            <p class="bx">打ち合わせ</p>
                          </li>
                          <li>
                            <p class="bx">見積作成</p>
                          </li>
                        </ol>
                      </div>
                    </li>
                    <li>
                      <div class="ins_wrap_flow">
                        <p class="ico_back">戻り</p>
                        <ol class="ins_lst_flow">
                          <li>
                            <p class="bx">図面制作</p>
                          </li>
                          <li>
                            <p class="bx">CG制作</p>
                          </li>
                          <li>
                            <p class="bx">見積作成</p>
                          </li>
                        </ol>
                      </div>
                    </li>
                    <li>
                      <div class="ins_wrap_flow">
                        <p class="ico_back">戻り</p>
                        <ol class="ins_lst_flow">
                          <li>
                            <p class="bx">製造図面</p>
                          </li>
                          <li>
                            <p class="bx">製造データ</p>
                          </li>
                          <li>
                            <p class="bx">見積作成</p>
                          </li>
                          <li>
                            <p class="bx">製造準備</p>
                          </li>
                        </ol>
                      </div>
                    </li>
                  </ol>
                </div>
                <div class="wrap_lst_flow2">
                  <ul class="lst_flow2">
                    <li>
                      <ol class="ins_lst_flow">
                        <li>
                          <p class="bx">製造準備</p>
                        </li>
                        <li>
                          <p class="bx">製造</p>
                        </li>
                        <li>
                          <p class="bx">配送</p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <ol class="ins_lst_flow">
                        <li>
                          <p class="bx">現調</p>
                        </li>
                        <li>
                          <p class="bx">採寸</p>
                        </li>
                        <li>
                          <p class="bx">施工</p>
                        </li>
                      </ol>
                    </li>
                    <li>完成</li>
                  </ul>
                </div>
              </article>
              <article class="arti_flow">
                <h5 class="tit">カグルのオーダー家具</h5>
                <p class="lead">
                  オーダー家具製造システム<br>
                  によって低価格<br>
                  & 短納期でお届け！
                </p>
                <div class="wrap_lst_flow3">
                  <p class="logo">
                    <strong>カグル.</strong>
                  </p>
                  <ol class="lst_flow3">
                    <li>
                      <p class="bx">お客様が<br>プランニング</p>
                    </li>
                    <li>
                      <p class="ins_lead">
                        サーバーが<br>全てのデータを<br>自動生成
                      </p>
                      <ul class="ins_lst_flow bx">
                        <li>図面</li>
                        <li>CG</li>
                        <li>見積書</li>
                        <li>製造データ</li>
                        <li>製造準備</li>
                      </ul>
                    </li>
                  </ol>
                </div>
                <div class="wrap_lst_flow2">
                  <p class="tx">
                    <strong>メーカー</strong>
                  </p>
                  <ul class="lst_flow2 type2">
                    <li>
                      <ol class="ins_lst_flow">
                        <li>
                          <p class="logo">CANDEAL</p>
                        </li>
                        <li>
                          <p class="bx">製造</p>
                        </li>
                        <li>
                          <p class="bx">配送</p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <ol class="ins_lst_flow">
                        <li>
                          <p class="bx">現調</p>
                        </li>
                        <li>
                          <p class="bx">採寸</p>
                        </li>
                        <li>
                          <p class="bx">施工</p>
                        </li>
                      </ol>
                    </li>
                    <li>完成</li>
                  </ul>
                </div>
              </article>
            </div>
          </section>
          <div v-if="headerType === '0'">
            <section class="sec_about">
              <h1 class="tit1">ユーザー登録</h1>
              <p class="lead_upper">
                カグルのご利用にはユーザー登録が必要です。<br>
                以下のボタンからご登録ください。
              </p>
              <div class="btn_area">
                <a class="btn1" @click="btnRegistUserClick()">登録する</a>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// kagull Module
import Header from '../components/common/HomeIconHeader'

export default {
  props: {
    headerType: {
      type: String,
      default: '0'
    }
  },
  components: {
    'kg-header': Header
  },
  methods: {
    btnRegistUserClick: function () {
      this.$router.push('/kagull/user/registtop')
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/About.vue